import { axiosService } from '../.';

export default class CloneOrganizationReference {
    public async execute(data: CloneOrganizationReferenceInputDto): Promise<void> {
        await axiosService.instance.post('references/organization/clone', data);
    }
}

export class CloneOrganizationReferenceInputDto {
    public readonly referenceId: number;

    constructor(referenceId: number) {
        this.referenceId = referenceId;
    }
}

export const cloneOrganizationReference = new CloneOrganizationReference();
